// importing external modules
import { BapiReturnCode } from './../common/bapi_return_code.model';
import { BapiReturnList } from './../common/bapi_return_list.model';

// class declaration
export class LotCharactsResponse {
  // composition of the response
  public bapi_return_code: BapiReturnCode;
  public bapi_return_list: BapiReturnList;
  public contained_bean = [];
  // reset the model
  reset() {
    this.bapi_return_code = new BapiReturnCode();
    this.bapi_return_list = new BapiReturnList();
    this.contained_bean = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/model/lot/lot_characts_response.model.ts